import React, { createContext, useState, useContext, useEffect } from 'react';
import i18n from './i18n';

import { CustomProvider } from 'rsuite';
import { useSearchParams } from 'react-router-dom';
import { ruRU, enUS } from 'rsuite/locales';
const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

function setCookie(name, value) {
    // SameSite=Lax важно для iOS PWA; cookie копируются при установке на главный экран
    document.cookie = `${name}=${encodeURIComponent(String(value))}; path=/; max-age=31536000; SameSite=Lax`;
}

export const LanguageProvider = ({ children, theme }) => {
    const [searchParams] = useSearchParams();

    const getInitialLanguage = () => {
        const fromQuery = searchParams.get('lang');
        if (fromQuery) return fromQuery;
        try {
            const stored = window.localStorage?.getItem('lang');
            if (stored) return stored;
        } catch (_) {
            // ignore
        }
        return 'ru';
    };

    const [language, setLanguage] = useState(getInitialLanguage);
    const [usedLocale, setUsedLocale] = useState(ruRU);
    const [hasPermission, setHasPermission] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);

    useEffect(() => {
        try {
            window.localStorage?.setItem('lang', language);
        } catch (_) {
            // ignore
        }

        // Для iOS сохраняем язык в cookie, чтобы при установке PWA он “переехал” в установленное приложение
        try {
            if (isIOS()) {
                setCookie('lang', language);
            }
        } catch (_) {
            // ignore
        }

        i18n.changeLanguage(language);
        if (language === 'ru') {
            setUsedLocale(ruRU);
        } else if (language === 'kz') {
            setUsedLocale(ruRU); // Using Russian locale as fallback for Kazakh
        } else {
            setUsedLocale(enUS);
        }
    }, [language]);

    return (
        <LanguageContext.Provider
            value={{
                language,
                setLanguage,
                hasPermission,
                setHasPermission,
                mediaRecorder,
                setMediaRecorder,
            }}
        >
            <CustomProvider theme={theme} locale={usedLocale}>
                {children}
            </CustomProvider>
        </LanguageContext.Provider>
    );
};
